import { render, staticRenderFns } from "./SideBarSmall.vue?vue&type=template&id=f654f2d0&scoped=true&"
import script from "./SideBarSmall.vue?vue&type=script&lang=js&"
export * from "./SideBarSmall.vue?vue&type=script&lang=js&"
import style0 from "./SideBarSmall.vue?vue&type=style&index=0&id=f654f2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f654f2d0",
  null
  
)

export default component.exports